

// src/parseConfig.js


import Parse from 'parse';


Parse.initialize("1KWICaIdNMwPL9Y0npgflLFlhM7XBvK3HJrTw64B", "gTGieeOeqC3DWPDUNeTRo64OtrkRIqzoH2Wx7wJ2");

Parse.serverURL = 'https://parseapi.back4app.com';


export default Parse;


// Expose Google Maps API key here too
export const gmApiKey = "AIzaSyDt5jsMtqzkg7I2jHMLPlTmeXFcvMvgs_0";  // New dedicated key for the web app.
